import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button } from '@mui/material';
import { Link } from "react-router-dom";
import { Delete as DeleteIcon, Edit as EditIcon } from '@mui/icons-material';

import { useTrans } from '~/hooks/useTrans';
import { IUserAdmin } from "~/providers/interfaces";
import Loader from '~/components/Loader';
import { getLink } from "~/providers/route";
import WysiwygDisplay from "~/components/WysiwygDisplay";

import "./style.less";

export type TApiUserTableName = "edit" | "delete" | "note";

interface IAdminApiUsersTable {
	loading: boolean;
	items: Array<IUserAdmin>;
	onSignal: (name: TApiUserTableName, userData: IUserAdmin) => void;
}

export default function AdminApiUsersTable({
	loading = true,
	items = [],
	onSignal = () => {},
}: IAdminApiUsersTable) {
	const { trans } = useTrans();
	const HEADERS = [
		"adminApiUsersTable.email",
		"adminApiUsersTable.maxProjectCount",
		"adminApiUsersTable.note",
		"adminApiUsersTable.banned",
		"",
	];
	const HEADERS_CENTER = [
		HEADERS[1],
	];

	function getEmailLink(user: IUserAdmin) {
		return getLink("admin-projects", true, { keyword: user.email });
	}

	function getHeaderClassName(header: string) {
		const parts: Array<string> = [];
		const headerParts = header.split(".");

		parts.push("adminApiUsersTable__header");

		if (headerParts.length > 1) {
			parts.push(headerParts[headerParts.length - 1]);
		}

		return parts.join(" ");
	}

	return <TableContainer component={Paper}>
		<Table sx={{ minWidth: 650 }} aria-label="table">
			<TableHead>
				<TableRow>
					{ HEADERS.map(header => <TableCell sx={{ fontWeight: "bold", ...HEADERS_CENTER.includes(header) ? { textAlign: "center" } : {} }} key={header} className={getHeaderClassName(header)}>
						{ trans(header) }
					</TableCell>) }
				</TableRow>
			</TableHead>
			<TableBody>
				{ items.map(user => (<TableRow key={user.email}>
					<TableCell>
						<Link to={getEmailLink(user)}>
							{ user.email }
						</Link>
					</TableCell>
					<TableCell className="adminApiUsersTable__center">
						{ user.maxProjectCount }
					</TableCell>
					<TableCell className="adminApiUsersTable__wysiwyg">
						<WysiwygDisplay html={ user.projectCountDescription } maxHeight={40} />
					</TableCell>
					<TableCell>
						{ user.banned ? trans("adminApiUsersTable.banned") : "" }
					</TableCell>
					<TableCell>
						<div className="adminApiUsersTable__buttons">
							<Button color="success" onClick={() => onSignal("edit", user)} title={trans("adminApiUsersTable.edit")}>
								<EditIcon />
							</Button>
							<Button color="success" onClick={() => onSignal("delete", user)} title={trans("adminApiUsersTable.delete")}>
								<DeleteIcon />
							</Button>
						</div>
					</TableCell>
				</TableRow>)) }
				{ items.length === 0 && <TableRow>
					<TableCell colSpan={HEADERS.length} style={{ textAlign: "center" }}>
						{ loading && <Loader msg={trans("loadingData")} /> }
						{ !loading && trans("emptyTable") }
					</TableCell>
				</TableRow> }
			</TableBody>
		</Table>
	</TableContainer>;
}
